// title.service.ts
import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class TitleService {
    private defaultTitle = 'warmify.partnereach.com';

    constructor(
        private titleService: Title,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {
        this.router.events
            .pipe(filter((event) => event instanceof NavigationEnd))
            .subscribe(() => {
                const title = this.getTitle(this.activatedRoute);
                console.log('title', title);
                this.titleService.setTitle(
                    title
                        ? `${title} - ${this.defaultTitle}`
                        : this.defaultTitle
                );
            });
    }

   private getTitle(route: ActivatedRoute): string | null {
        const title = route.snapshot.data['title'];
        if (title) {
            return title;
        } else if (route.firstChild) {
            return this.getTitle(route.firstChild);
        }
        return null;
    }

    setTitle(name?) {
        console.log('title name', name);
        this.titleService.setTitle(
            name ? `${name} - ${this.defaultTitle}` : this.defaultTitle
        );
    }
}
